import {HandleTextChange, HandlePassChange, CallAPI, Check} from '../../utils/util.js';
import React, { Component } from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import Alert from 'react-bootstrap/Alert';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params }}
            />
        );
    }
    return ComponentWithRouterProp;
}


class ChangePassword extends Component {
    constructor(props) {
        super(props);

        // Init state and local storage
        this.state = {
            "email": "",
            "oldPass": "",
            "pass": "",
            "modalVariant": "",
            "modalMessage": ""
        };
        
        this.handleTextChange = HandleTextChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePassChange = HandlePassChange.bind(this);
        this.check = Check.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        CallAPI(this.state, "/users/changepass", 'POST', (res) => {
            if (res && res.length > 0 && res[0].success){
                this.props.router.navigate("/")
            } else {
                this.setState({
                    "modalVariant": "danger",
                    "modalMessage": "Failed to change password: " + res[0].message[0]
                });
            }
            
        });
    }

    render = () => {
        return (
            <div className="wow">
                <div className="boxu">
                    <h2 className="signIn">Change Password</h2>
                    <p className="signInMessage">Enter your current password and choose a new one.</p>

                    {this.state.modalVariant && (
                        <Alert variant={this.state.modalVariant} style={{ marginBottom: '16px' }}>
                            {this.state.modalMessage}
                        </Alert>
                    )}

                    <form onSubmit={(e) => this.handleSubmit(e)} noValidate>
                        <div style={{ marginBottom: '14px' }}>
                            <label className="signInBox" htmlFor="oldPass">Current Password</label>
                            <input
                                type="password"
                                id="oldPass"
                                name="oldPass"
                                required
                                placeholder="••••••••"
                                onChange={(e) => this.handlePassChange(e, this)}
                                autoComplete="current-password"
                            />
                        </div>

                        <div style={{ marginBottom: '14px' }}>
                            <label className="signInBox" htmlFor="pass">New Password</label>
                            <input
                                type="password"
                                id="pass"
                                name="pass"
                                required
                                placeholder="••••••••"
                                onChange={(e) => this.handlePassChange(e, this)}
                                autoComplete="new-password"
                            />
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <label className="signInBox" htmlFor="newPass2">Confirm New Password</label>
                            <input
                                type="password"
                                id="newPass2"
                                name="newPass2"
                                required
                                placeholder="••••••••"
                                onChange={(e) => this.check(e, this)}
                                autoComplete="new-password"
                            />
                        </div>

                        <button type="submit" className="logSubmit">
                            Change Password
                        </button>
                    </form>
                </div>
            </div>
        );
    };

}

export default withRouter(ChangePassword)
